import { useState, useEffect } from 'react';
import { useAuth as useClerkAuth, useUser } from '@clerk/clerk-react';
import { RootState } from '@/store';
import { getCurrentUser, getIsLoadingProfile, setLoadingProfile } from '@/store/slices/auth';
import { useDispatch, useSelector } from 'react-redux';

export const useAuth = () => {
  const { isSignedIn, isLoaded } = useClerkAuth();
  const { user } = useUser();
  const isLoadingProfile = useSelector((state: RootState) => state.auth.isLoadingProfile);
  const dispatch = useDispatch();

  const setLoading = (val: boolean) => dispatch(setLoadingProfile(val));

  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;

    // When Clerk is ready, auth loading is done
    setAuthLoading(false);
  }, [isLoaded]);

  return {
    user: isSignedIn ? user : null,
    loading: !isLoaded || authLoading,
    isLoggingIn: isLoadingProfile,
    setLoggingIn: setLoading
  };
};
